import React from 'react';
import { Outlet } from 'react-router-dom';
import '../i18n.js'
import { useTranslation } from 'react-i18next';
// import Header from '../components/common/header';
import Header from '../components/common/headerNew.js';
import AdminSidebar from "../admin/common/sidebar/Sidebar";

export default function InventoryHeader({ menutyp, Fulhandle, Fullhandle }) {
    const { i18n } = useTranslation();
    const fullscreenHandle = Fullhandle || Fulhandle;

    localStorage.setItem('middlewareLocations', '');
    return (
        <div className='main-layout-apps'>
            <div className={`main-content-wrapper ${menutyp ?? ''}`}>
                <AdminSidebar />
                <div className='main-content-wrapper-right'>
                    <Header Fullhandle={fullscreenHandle} i18n={i18n} />
                    <Outlet />
                </div>
            </div>
        </div>
    );
};
